import type { Configuration } from '@azure/msal-browser';

export interface MsalEnv {
  clientId: string;
  tenantId: string;
  /** Full API scope, e.g. api://servicedesk-api/access_as_agent */
  apiScope: string;
  redirectUri?: string;
}

/**
 * MSAL config for a public SPA client. sessionStorage keeps tokens per-tab;
 * silent renewal uses MSAL's rotating refresh tokens (see docs/architecture.md).
 */
export function createMsalConfig(env: MsalEnv): Configuration {
  return {
    auth: {
      clientId: env.clientId,
      authority: `https://login.microsoftonline.com/${env.tenantId}`,
      redirectUri: env.redirectUri ?? window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
}

export function apiScopes(env: Pick<MsalEnv, 'apiScope'>): string[] {
  return [env.apiScope];
}
